var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-expand-lg navbar-light"},[_c('router-link',{staticClass:"nav-item nav-link btn btn-danger",attrs:{"to":'/' + _vm.event._id}},[_vm._v("Canlı Yayına Dön")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }